<template>
  <button :class="buttonClass" @click="emitClick">
  </button>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: 'cancel'
        }
    },
    methods: {
        emitClick() {
            this.$emit('click');
        }
    },
    computed: {
        buttonClass() {
            return [`small-button`, `variant-${this.variant}`];
        }
    }
}
</script>

<style scoped>
.small-button {
  background-size: 1.2vw;
  width: 2.7vw;
  height: 3.6vh;
  border-radius: 0.35vw;
  border: 0;
  margin-left: 0.6vw;
  cursor: pointer;
}

.variant-cancel {
    background: url("../assets/delete.png") center #e2223b no-repeat;
    background-size: 1.2vw;
}

.variant-accept {
    background: url("../assets/accept.png") center no-repeat #129b81;
    background-size: 1.2vw;
}

.variant-edit {
    background: url("../assets/edit.svg") center no-repeat #A4A3A1;
    background-size: 1.2vw;
}
</style>